<template>
  <div v-show="isVisible" ref="popup" class="popUp fixed top-0 left-0 w-full h-full" :class="[model.class]">
    <div class="flex w-full h-full justify-center items-center">
      <div class="popTent relative">

        <div class="popTlt">{{ model.title }}</div>
        <!-- popup內容-->
        <div class="popDesBox" :style="{ 'text-align': model.body.textAlign }" v-html="model.message"></div>

        <!--指令-->
        <div class="popBtn flex">
          <button v-if="isConfirmMode" class="submitBtn" @click="onConfirm">{{ model.confirm.name }}</button>
          <button v-if="isConfirmMode" class="changeBtn " @click="onCancel">{{ model.close.name }}</button>
          <button v-if="!isConfirmMode" class="changeBtn" @click="onConfirm">{{ model.close.name }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted } from "vue";
import { useRouter } from 'vue-router'

const defaultModel = {
  title: '確認',
  body: {
    textAlign: 'center',
  },
  message: '',
  close: {
    type: 1,
    name: '關閉',
    to: '/',
  },
  confirm: {
    name: '確認',
  },
  class: 'pop_allowance',
};

const model = JSON.parse(JSON.stringify(defaultModel));

const router = useRouter()
const popup = ref(null);
const isVisible = ref(false)

let resolvePromise;
let isConfirmMode = false;

const r = {};
const init = () => { Object.assign(model, JSON.parse(JSON.stringify(defaultModel))); };
r.init = init;
r.get = () => model;
r.getInit = () => { init(); return model; };

// 修改 show 方法，接收 resolve 和 reject 函數
r.show = async (msg) => {
  if (msg) { model.message = msg }

  isConfirmMode = false;
  isVisible.value = true
  popup.value.classList.add('show');

  return new Promise((resolve) => {
    resolvePromise = resolve;
  });
}

const onConfirm = () => {
  if (resolvePromise) { resolvePromise(true); }
  close();
};

// 修改 close 方法
const close = () => {
  isVisible.value = false
  popup.value.classList.remove('show');

  if (model.close.type == 2) { router.push(model.close.to); }
};
r.close = close;

const onCancel = () => {
  if (resolvePromise) { resolvePromise(false); }
  close();
};

// 新增一個異步的 confirm 函數
r.confirm = async (msg) => {
  if (msg) { model.message = msg }

  isConfirmMode = true;
  isVisible.value = true
  popup.value.classList.add('show');

  return new Promise((resolve) => {
    resolvePromise = resolve;
  });
};

defineExpose(r);
</script>

<style scoped>
.show {
  opacity: 0;
  animation: fadeIn 0.3s linear forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.changeBtn,
.submitBtn {
  width: calc(50% - 0.625rem) !important;
  margin-bottom: 0;
}

.popDesBody {
  padding: 2em 1em;
  box-shadow: inset 1px 1px 5px 0px #ccc;
  background-color: #e9e9e975;
  border-radius: 0.5em;
}

.popUp {
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.popUp .popUpMask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.popUp .closeMask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.popTent {
  background-color: #FDFAEE;
  min-width: 22.5rem;
  padding: 1.5rem;
  border-radius: 1.25rem;
  text-align: center;
}

.popTent .popTlt {
  font-size: 1.3rem;
  font-weight: 900;
  color: #149CB2;
  border-radius: 10em;
  margin-bottom: 1em;
}

.popTent .submitBtn {
  max-width: none;
  width: 100%;
  margin-bottom: 0;
}

.popUpCloseBtn {
  position: absolute;
  width: 4.5rem;
  bottom: 99%;
  right: 0;
  background-color: #ffffff;
}

.pop_allowance {
  opacity: 0;
  -webkit-transition: 0.38s;
  transition: 0.38s;
}

.pop_allowance.show {
  opacity: 1;
}

.pop_serviceSubmit {
  opacity: 0;
  -webkit-transition: 0.38s;
  transition: 0.38s;
}

.pop_serviceSubmit.show {
  opacity: 1;
}

.pop_serviceSubmit .popTent {
  width: 29.375rem;
}

.pop_serviceSubmit .popDesBox {
  text-align: left;
}

.popup_serviceCancel {
  opacity: 0;
  -webkit-transition: 0.38s;
  transition: 0.38s;
}

.popup_serviceCancel.show {
  opacity: 1;
}

.popup_serviceCancel .popTent {
  width: 22.5rem;
}

.popup_serviceCancel .changeBtn {
  margin-top: 1em;
}

@media screen and (max-width: 767px) {
  .popTent {
    width: calc(100vw - 2.5rem) !important;
    min-width: 0;
  }
}
</style>
